<div class="main-content">
  <app-header
    [title]="'HEADER.TITLE_REQ_DOCUMENTS' | translate"
    [subtitle]="'HEADER.SUBTITLE_REQ_DOCUMENTS' | translate"
    />

  <div class="row mt-5">
    <div class="col-12 d-flex justify-content-end gap-3">
      <button
        class="create-doc-button"
        [routerLink]="['/repository', 'required-documents', 'new']"
        *appHasRole="['ADMIN']"
        >
        {{ 'REPOSITORY.CREATE_DOC_BUTTON' | translate }}
      </button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <app-icam-container [iconName]="'repository'" [iconColor]="'white'">
        <app-table
          [allValues$]="allRequiredDocuments$"
          [type]="'required_document'"
          (selectedFilter)="onFilterSelected($event)"
          [hasChart]="false"
          [filters$]="requiredDocumentFilter$"
          (selectedPage)="onPageSelected($event)"
          [prevPage]="reqDocPrevPage"
          [currentPage]="reqDocCurrentPage"
          [nextPage]="reqDocNextPage"
          [totalPages]="reqDocTotalPages"
          [hasKeywordFilter]="true"
          [useInlineKeywordFilter]="true"
          [keywordFilterName]="'name'"
          [keywordFilterPlaceholder]="'FILTER.SEARCH_REQUIRED_DOCUMENTS'"
          [initialFilters]="requiredDocumentFilters"
          />
      </app-icam-container>
    </div>
  </div>
  @if (!showSuccess && !showError) {
    <div class="mt-4 mb-4">
      @if (!showSuccess && !showError) {
        <app-back-button
          [linkText]="'TABLE.BUTTONS.required_document.goToRepository'"
          (click)="goToRepository()"
          />
      }
    </div>
  }
</div>
<app-footer-copyright />
